import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const protocolQALogApi = createApi({
  baseQuery,
  reducerPath: 'protocolQALogApi',
  endpoints: builder => ({
    getProtocolQALog: builder.query<any, any>({
      query: ({ site_id, study_id, country, protocol_qa_level, application, from = -1, size = -1, data }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.getAll)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&protocol_qa_level=${protocol_qa_level}&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.create, { key: urlKeys.study_id, value: study_id })}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&protocol_qa_level=${data.protocol_qa_level}&application=${
          data.application
        }&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    copyProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.conductProtocolQALog.copyQuestion,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?${study_id !== null ? `study_id=${study_id}` : ''}${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateOtherResponseProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, id, application, protocol_qa_level }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.updateOtherResponse, {
          key: urlKeys.id,
          value: id
        })}?protocol_qa_level=${protocol_qa_level}${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateResponseProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, id, application, protocol_qa_level }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.updateResponse, {
          key: urlKeys.id,
          value: id
        })}?protocol_qa_level=${protocol_qa_level}${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, id, application, protocol_qa_level }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.update, {
          key: urlKeys.id,
          value: id
        })}?protocol_qa_level=${protocol_qa_level}${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateStatusProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, id, application, protocol_qa_level }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.updateStatus, {
          key: urlKeys.id,
          value: id
        })}?protocol_qa_level=${protocol_qa_level}${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateOthersProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, id, application, protocol_qa_level }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.updateOther, {
          key: urlKeys.id,
          value: id
        })}?protocol_qa_level=${protocol_qa_level}${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, id, application, protocol_qa_level }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.delete, {
          key: urlKeys.id,
          value: id
        })}?protocol_qa_level=${protocol_qa_level}${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteOthersProtocolQALog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, id, application, protocol_qa_level }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.deleteOther, {
          key: urlKeys.id,
          value: id
        })}?protocol_qa_level=${protocol_qa_level}${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getProtocolQALogBasedOnDateRange: builder.query<any, any>({
      query: ({ site_id, study_id, country, protocol_qa_level, application, start_date, end_date, data }) => ({
        url: `${formatString(endPoints.conductProtocolQALog.getAll)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&protocol_qa_level=${protocol_qa_level}&start_date=${start_date}&end_date=${end_date}&application=${application}&application_section=CONDUCT&application_module_section=PROTOCOL QA`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetProtocolQALogQuery,
  useCreateProtocolQALogMutation,
  useCopyProtocolQALogMutation,
  useUpdateOtherResponseProtocolQALogMutation,
  useUpdateResponseProtocolQALogMutation,
  useUpdateProtocolQALogMutation,
  useUpdateOthersProtocolQALogMutation,
  useUpdateStatusProtocolQALogMutation,
  useDeleteProtocolQALogMutation,
  useDeleteOthersProtocolQALogMutation,
  useLazyGetProtocolQALogBasedOnDateRangeQuery
} = protocolQALogApi;
